import styled from 'styled-components'
import { StyledProductBranding } from '@components/ApparelProduct/ApparelProduct.styles'
import { Border } from '../../../../../velasca-ui/src/ProductBranding/ProductBranding.styles'

export const Content = styled.div<{
  isUltraCondensedLayout: boolean
  legacyMode: boolean
}>`
  display: none;
  background: white;

  @media screen and (min-width: 1280px) {
    display: block;
    width: ${({ isUltraCondensedLayout }) =>
      isUltraCondensedLayout ? '877px' : '70vw'};
    max-width: var(--container-max-width);
    ${({ legacyMode }) =>
      legacyMode
        ? 'height: fit-component;'
        : `
        aspect-ratio: 215 / 132;
      `};
    margin: 0 auto;
    position: relative;
    padding: 2rem 0;

    ${StyledProductBranding}, ${Border} {
      display: none;
    }

    .product-slider {
      margin-bottom: 0;
    }
  }
`
